const compatibilityReducer = (state = {}, action) => {
  switch (action.type) {
    case `GET_COMPATIBILITY_REPORT_SUCCESS`:
      return {
        ...state,
        yourSign: action.data.your_sign,
        partnerSign: action.data.your_partner_sign,
        report: action.data.compatibility_report,
        percentage: action.data.compatibility_percentage,
      };
    case `GET_COMPATIBILITY_REPORT_FAILURE`:
      return {
        ...state,
        yourSign: ``,
        partnerSign: ``,
        report: `There was an error processing your report, please try again later!`,
        percentage: `--`,
      };
    case `GET_COMPATIBILITY_REPORT_START`:
      return {
        ...state,
        report: `Loading...`,
        percentage: `--`,
      };
    default:
      return state;
  }
};

export default compatibilityReducer;
